import { render, staticRenderFns } from "./brandTrainingRetailerAddStep3Dialog.vue?vue&type=template&id=6fc07c4a&scoped=true"
import script from "./brandTrainingRetailerAddStep3Dialog.vue?vue&type=script&lang=js"
export * from "./brandTrainingRetailerAddStep3Dialog.vue?vue&type=script&lang=js"
import style0 from "./brandTrainingRetailerAddStep3Dialog.vue?vue&type=style&index=0&id=6fc07c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc07c4a",
  null
  
)

export default component.exports